import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/pages/Services";
import { useCollection } from "@/hooks/useCollection";
import { fileUrl } from "@/lib/api";

export default function Portfolio() {
  const { items } = useCollection("portfolio");
  return (
    <div>
      <PageHeader eyebrow="Portofolio" title="Karya & Proyek Kami" subtitle="Beberapa proyek nyata yang telah kami kerjakan bersama klien dari berbagai sektor." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.06}>
              <div className="group bg-ll-card rounded-2xl overflow-hidden card-hover gold-border" data-testid={`portfolio-card-${i}`}>
                <div className="h-56 overflow-hidden relative">
                  <img src={fileUrl(p.image)} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-[10px] btn-gold font-bold">{p.category}</span>
                </div>
                <div className="p-6">
                  <div className="text-xs text-gold mb-1">{p.client}</div>
                  <h3 className="font-syne font-semibold text-lg text-white">{p.title}</h3>
                  <p className="text-sm text-white/60 mt-2">{p.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
          {items.length === 0 && <p className="text-white/50">Belum ada portofolio.</p>}
        </div>
      </section>
    </div>
  );
}
